"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removePreLoginRouterState = exports.getPreLoginRouterState = exports.savePreLoginRouterState = exports.useSigninMessageNavigation = exports.isHttpLocation = void 0;
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const js_cookie_1 = __importDefault(require("js-cookie"));
const react_router_1 = require("react-router");
const cookieUtils_1 = require("../components/cookies/cookieUtils");
const PRE_LOGIN_ROUTER_STATE_COOKIE = 'TS_GO_PRE_LOGIN_ROUTER_STATE';
exports.isHttpLocation = globalThis.location && globalThis.location.protocol === 'http:';
const COOKIE_DEFAULTS = {
    sameSite: 'lax',
    secure: !exports.isHttpLocation,
};
const lexico = new lexico_1.default();
const userAccountLocked = lexico.tr('Your user account has been locked');
const emailSupportUnlockMsg = lexico.tr('Please email Customer Support to unlock your account.');
const supportEmail = 'support@mail.virtualcards.business.hsbc.com';
const LOCKED_ACCOUNT_MESSAGES = {
    password: {
        heading: userAccountLocked,
        message: lexico.tr("You've entered an invalid email or password too many times."),
        subMessage: emailSupportUnlockMsg,
        supportEmail,
    },
    activation: {
        heading: userAccountLocked,
        message: lexico.tr("You've entered the wrong activation code too many times."),
        subMessage: emailSupportUnlockMsg,
        supportEmail,
    },
    mfa: {
        heading: userAccountLocked,
        message: lexico.tr("You've entered the wrong code too many times."),
        subMessage: emailSupportUnlockMsg,
        supportEmail,
    },
    accountNotCreated: {
        heading: "You've not completed your activation",
        message: "So you won't be able to proceed any further at this time.",
        subMessage: 'Please email Customer Support to resolve this issue.',
        supportEmail,
    },
};
const useSigninMessageNavigation = () => {
    const navigate = (0, react_router_1.useNavigate)();
    const navigateToLockedAccountMessage = (type) => {
        navigateToSigninMessage(LOCKED_ACCOUNT_MESSAGES[type]);
    };
    const navigateToSigninMessage = (state) => {
        void navigate('/signin/message', { state });
    };
    return { navigateToLockedAccountMessage, navigateToSigninMessage };
};
exports.useSigninMessageNavigation = useSigninMessageNavigation;
const savePreLoginRouterState = (state) => {
    const { preferences } = (0, cookieUtils_1.getStoredConsent)();
    // on Amex, we set cookie regardless
    // for hsbc we set it  only  if preferences are accepted on the cookie banner
    if (globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP || preferences) {
        const inFiveMinutes = new Date(Date.now() + 5 * 60 * 1000);
        js_cookie_1.default.remove(PRE_LOGIN_ROUTER_STATE_COOKIE, COOKIE_DEFAULTS);
        js_cookie_1.default.set(PRE_LOGIN_ROUTER_STATE_COOKIE, JSON.stringify(state), {
            ...COOKIE_DEFAULTS,
            expires: inFiveMinutes,
        });
    }
};
exports.savePreLoginRouterState = savePreLoginRouterState;
const getPreLoginRouterState = () => {
    const routerStateCookie = js_cookie_1.default.get(PRE_LOGIN_ROUTER_STATE_COOKIE);
    const defaultState = { redirectTo: '', redirectParams: '' };
    if (routerStateCookie) {
        try {
            (0, exports.removePreLoginRouterState)();
            return JSON.parse(routerStateCookie);
        }
        catch {
            return defaultState;
        }
    }
    return defaultState;
};
exports.getPreLoginRouterState = getPreLoginRouterState;
const removePreLoginRouterState = () => {
    js_cookie_1.default.remove(PRE_LOGIN_ROUTER_STATE_COOKIE, COOKIE_DEFAULTS);
};
exports.removePreLoginRouterState = removePreLoginRouterState;
